import { render, staticRenderFns } from "./item_type_icon.vue?vue&type=template&id=f517bb3e&"
import script from "./item_type_icon.vue?vue&type=script&lang=js&"
export * from "./item_type_icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "item_type_icon.vue"
export default component.exports